jQuery(function($){
	// fade bootstrap alerts
	$(".alert").addClass('fadein'); 

	window.setTimeout(function() {
		$(".alert").removeClass('fadein'); 
	}, 4000);

	window.setTimeout(function() {
		$(".alert").hide(); 
	}, 5000);
});
